import gql from "graphql-tag";

export const UpdateList_GQL = gql`
  mutation(
    $inst_id: String!
    $account_id: String!
    $id: String!
    $name: String!
  ) {
    listUpdate(instId: $inst_id, accountId: $account_id, id: $id, name: $name) {
      data {
        updatedAt
        id
        accountId
        system
        shared
        name
        deletedAt
        orderBy
        attributes
      }
      message
      code
    }
  }
`;
